import Login from './components/login.vue'
import Home from './components/home.vue'
import hyjm from './components/layout/hyjm.vue'
import yggk from './components/layout/yggk.vue'
import lsjl_jt from './components/layout/lsjl_jt.vue'
import lsjl_lt from './components/layout/lsjl_lt.vue'
import lsjl_lx from './components/layout/lsjl_lx.vue'
import lsjl_wj from './components/layout/lsjl_wj.vue'
import ssjk_pm from './components/layout/ssjk_pm.vue'
import ssjk_dp from './components/layout/ssjk_dp.vue'
import xwsj_wz from './components/layout/xwsj_wz.vue'
import xwsj_rj from './components/layout/xwsj_rj.vue'
import xwsj_jq from './components/layout/xwsj_jq.vue'
import xwsj_kg from './components/layout/xwsj_kg.vue'
import xtxx_jc from './components/layout/xtxx_jc.vue'
import xtxx_xt from './components/layout/xtxx_xt.vue'
import xtxx_rj from './components/layout/xtxx_rj.vue'
import xtxx_xx from './components/layout/xtxx_xx.vue'

let routes = [
    {
        path: '/',
        component: Login,
        name: '',
        hidden: true,
        meta: {
            title: "超级眼登录页",
        }
    },
    {
        path: '/home',
        component: Home,
        name: '',
        meta: {
            title: "超级眼"
        },
        leaf: true,//只有一个节点
        iconCls: 'el-icon-menu', //图标样式class
    },
    {
        path: '/home',
        component: Home,
        name: '菜单',
        meta: {
            title: "超级眼"
        },
        // leaf: true,//只有一个节点
        iconCls: 'el-icon-message', //图标样式class
        children: [
            {
                path: '/hyjm',
                component: hyjm,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/yggk',
                name: 'yggk',
                component: yggk,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/lsjl_jt',
                component: lsjl_jt,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/lsjl_lt',
                component: lsjl_lt,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/lsjl_lx',
                component: lsjl_lx,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/lsjl_wj',
                component: lsjl_wj,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/ssjk_pm',
                component: ssjk_pm,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/ssjk_dp',
                component: ssjk_dp,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/xwsj_wz',
                component: xwsj_wz,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/xwsj_rj',
                component: xwsj_rj,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/xwsj_jq',
                component: xwsj_jq,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/xwsj_kg',
                component: xwsj_kg,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/xtxx_jc',
                component: xtxx_jc,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/xtxx_xt',
                component: xtxx_xt,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/xtxx_rj',
                component: xtxx_rj,
                meta: {
                    title: "超级眼"
                },
            },
            {
                path: '/xtxx_xx',
                component: xtxx_xx,
                meta: {
                    title: "超级眼"
                },
            }
        ]
    },
];

export default routes;